import Vue from "vue";
import Router from "vue-router";
import Account from "./views/Account.vue";
import AccountUpdate from "./views/AccountUpdate.vue";
import RecentPayPalTransaction from "./views/accounts/RecentPayPalTransaction.vue";
import DiscourseSSO from "@/views/DiscourseSSO.vue";
import PasswordReset from "@/views/PasswordReset.vue";
import PlanTrial from "@/views/PlanTrial.vue";
import Shows from "@/views/Shows.vue";
import Upgrade from "@/views/Upgrade.vue";
import UpgradeProrated from "@/views/UpgradeProrated.vue";
import UpgradePayPal from "@/views/UpgradePayPal.vue";
import VideoFileDownload from "@/views/VideoFileDownload";

import ShowPlayer from "@/views/ShowPlayer";
import ShowPlayerPreviewOnly from "@/views/ShowPlayerPreviewOnly";
import ShowImport from "@/views/ShowImport";
import ShowImportFromURL from "@/views/ShowImportFromURL";

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.

// const ShowPlayer = () =>
//   import(/* webpackChunkName: "player" */ "./views/ShowPlayer.vue");
//
// const ShowPlayerPreviewOnly = () =>
//   import(
//     /* webpackChunkName: "preview_only" */ "./views/ShowPlayerPreviewOnly.vue"
//   );

// const ShowImport = () =>
//   import(/* webpackChunkName: "showimport" */ "./views/ShowImport.vue");

// const ShowImportFromURL = () =>
//   import(
//     /* webpackChunkName: "showimportfromurl" */ "./views/ShowImportFromURL.vue"
//   );

const ShowPlayerTestWalker = () =>
  import(
    /* webpackChunkName: "preview_only" */ "./views/ShowPlayerTestWalker.vue"
  );

const ShowPlayerMovementExperiment = () =>
  import(
    /* webpackChunkName: "player" */ "./views/ShowPlayerMovementExperiment.vue"
  );

const ShowPlayerCropExperiment = () =>
  import(
    /* webpackChunkName: "player" */ "./views/ShowPlayerCropExperiment.vue"
  );

const Converter = () =>
  import(/* webpackChunkName: "converter" */ "./views/Converter.vue");

const Groups = () =>
  import(/* webpackChunkName: "groups" */ "./views/Groups.vue");

const GroupEdit = () =>
  import(/* webpackChunkName: "group_edit" */ "./views/GroupEdit.vue");

const GroupEditDetails = () =>
  import(
    /* webpackChunkName: "group_edit_details" */ "./views/GroupEditDetails.vue"
  );

const MusicLibrary = () =>
  import(/* webpackChunkName: "musiclibrary" */ "./views/MusicLibrary.vue");

const Show = () => import(/* webpackChunkName: "show" */ "./views/Show.vue");

const ZipPlayerTest = () =>
  import(/* webpackChunkName: "zipplayertest" */ "./views/ZipPlayerTest.vue");

const DirectoryPlayerTest = () =>
  import(
    /* webpackChunkName: "dirplayertest" */ "./views/DirectoryPlayerTest.vue"
  );

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes: [
    {
      path: "/converter",
      name: "converter",
      component: Converter,
      meta: { login_required: true }
    },
    {
      path: "/hosting",
      name: "hosting",
      redirect: { name: "shows" }
    },
    {
      path: "/editor",
      redirect: { name: "shows" }
    },
    {
      path: "/shows",
      redirect: { name: "shows" }
    },
    {
      path: "/",
      name: "shows",
      component: Shows,
      meta: {
        login_required: true
      }
    },
    {
      path: "/shows/:id/import-tma",
      name: "show-import-tma",
      component: ShowImport,
      meta: { login_required: true, tmazip: true }
    },
    {
      path: "/shows/:id/import-zip",
      name: "show-import-zip",
      component: ShowImport,
      meta: { login_required: true, zip: true }
    },
    {
      path: "/shows/:id/import",
      name: "show-import",
      component: ShowImport,
      meta: { login_required: true, zip: false }
    },
    {
      path: "/shows/:id/import-url",
      name: "show-import-url",
      component: ShowImportFromURL,
      meta: { login_required: true }
    },
    {
      path: "/shows/:id",
      name: "show",
      component: ShowPlayer,
      meta: { login_required: true, hideNav: true }
    },

    {
      path: "/shows/:id/:mode",
      name: "show-mode",
      component: ShowPlayer,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/shows/:id/:mode/:highlight",
      name: "show-mode-highlight",
      component: ShowPlayer,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/preview-only/:id",
      name: "show-preview-only",
      component: ShowPlayerPreviewOnly,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/experimental/:id",
      name: "show-experimental",
      component: ShowPlayerMovementExperiment,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/experimental-crop/",
      name: "show-experimental-crop",
      component: ShowPlayerCropExperiment,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/admin/test/walker",
      name: "show-player-test-walker",
      component: ShowPlayerTestWalker,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/admin/test/walker/:startAtId",
      name: "show-player-test-walker-id",
      component: ShowPlayerTestWalker,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/shows-player/:id",
      name: "show-player",
      component: Show,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/shows-player/:id/:mode",
      name: "show-player-mode",
      component: Show,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/shows/:id/:mode/:highlight",
      name: "show-player-mode-highlight",
      component: Show,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/files/:id/download",
      name: "video-file-download",
      component: VideoFileDownload,
      meta: { login_required: false, hideNav: true }
    },
    {
      path: "/trial",
      name: "trial",
      component: PlanTrial
    },
    {
      path: "/password_reset",
      name: "password_reset",
      component: PasswordReset
    },
    {
      path: "/upgrade/",
      name: "upgrade_view",
      component: Upgrade
    },
    {
      path: "/upgrade/coupon/:coupon_id",
      name: "upgrade_view_coupon",
      component: Upgrade
    },
    {
      path: "/upgrade/:plan_id/",
      name: "upgrade-prorate",
      component: UpgradeProrated
    },
    {
      path: "/upgrade/paypal/:plan_id/",
      name: "upgrade-paypal",
      component: UpgradePayPal,
      meta: { login_required: true }
    },
    {
      path: "/account",
      name: "account",
      component: Account
    },
    {
      path: "/music",
      name: "music",
      component: MusicLibrary,
      meta: { login_required: true }
    },
    {
      path: "/account/update",
      name: "account-update",
      component: AccountUpdate
    },
    {
      path: "/account/latest-transaction/:version",
      name: "account-latest-transaction",
      component: RecentPayPalTransaction,
      meta: { login_required: true, hideNav: true }
    },
    {
      path: "/discourse/sso",
      name: "discourse-sso",
      component: DiscourseSSO,
      meta: { login_required: true }
    },
    {
      path: "/groups",
      name: "groups",
      component: Groups,
      meta: { login_required: true }
    },
    {
      path: "/groups/:id",
      name: "groups-edit",
      component: GroupEdit,
      meta: { login_required: true }
    },
    {
      path: "/groups/:id/Details",
      name: "groups-edit-details",
      component: GroupEditDetails,
      meta: { login_required: true }
    },
    {
      path: "/test/test/test",
      name: "test",
      meta: { hideNav: true },
      component: () =>
        import(/* webpackChunkName: "testtesttest" */ "./views/Test.vue")
    },
    {
      path: "/player/zip",
      name: "zip-player",
      meta: { hideNav: true },
      component: ZipPlayerTest
    },
    {
      path: "/player/zip/:hostingId",
      name: "zip-player-hosting",
      meta: { hideNav: true },
      component: ZipPlayerTest
    },
    {
      path: "/player/directory",
      name: "directory-player",
      meta: { hideNav: true },
      component: DirectoryPlayerTest
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/drag-test",
      name: "drag-test",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/DragTest.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "about" */ "./views/pages/PrivacyPolicy.vue"
        )
    },
    {
      path: "/terms",
      name: "terms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/pages/Terms.vue")
    },
    {
      path: "*",
      name: "404",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/pages/404.vue")
    }
  ]
});
